import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {CatalogSelectors} from '@store/catalog/catalog.selectors';
import {CatalogRecord} from '@store/catalog/catalog.types';
import {TruncateDirective} from '@aviary/directives/truncate.directive';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {CoverImageComponent} from '@aviary/components/cover-image/cover-image.component';
import {NamedRouterLinkDirective} from '@lib/directives/named-router-link/named-router-link.directive';
import {ViewportSelectors} from '@aviary/store/viewport/viewport.selectors';

@Component({
  selector: 'px-catalog-carousel-item',
  host: {
    class: 'flex flex-col space-between w-[6.25rem] md:w-[8.75rem]'
  },
  template: `
    @if ({
      isMdOrAbove: viewportSelectors.isMdAndUp | select
    }; as vm) {
      <a pxNamedRouterLink="CATALOG_BIB_DETAILS" [pxNamedRouterLinkParams]="{id: selectors.idAsStringFor(catalogRecord) | select}" class="h-fit px-0">
        <mx-cover-image [catalogRecord]="catalogRecord" [widthRem]="vm.isMdOrAbove ? 8.75 : 6.25" [heightRem]="8.75" [xPaddingRem]="0" [yPaddingRem]="0"
                        yAlignment="CENTER"/>

        <div class="w-full py-2">
          <p mxTruncate [mxTruncateMaxLines]="2" class="text-label-medium text-center md:text-label-large text-on-surface">
            {{ selectors.titleFor(catalogRecord) | select }}
          </p>
        </div>
      </a>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CoverImageComponent, TruncateDirective, SelectPipe, NamedRouterLinkDirective]
})
export class CatalogCarouselItemComponent {

  @Input({required: true}) public catalogRecord: CatalogRecord;
  public readonly selectors = CatalogSelectors.Stateless;
  public readonly viewportSelectors = ViewportSelectors;
}
